module.exports = __webpack_public_path__ + "static/img/plan.9934f93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plan.png
// module id = wEbZ
// module chunks = 1